var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-order",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7094",
    "data-name": "Rectangle 7094",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orders-icon",
    transform: "translate(2.678 2.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M4.084,14.048a.527.527,0,0,1,0-1.054H7.557a.527.527,0,0,1,0,1.054Zm5.791-1.527a.291.291,0,0,1,0-.582h.781a1.34,1.34,0,0,1,.7.184,1.1,1.1,0,0,1,.472.671.028.028,0,0,0,.008.023l.074.294h6.447a.288.288,0,0,1,.288.288.443.443,0,0,1-.015.089l-.752,3.029a.284.284,0,0,1-.28.221H12.883a1.183,1.183,0,0,0,.346.685,1.927,1.927,0,0,0,.958.11h3.337a.288.288,0,0,1,0,.575H14.192A2.252,2.252,0,0,1,12.9,17.9a1.848,1.848,0,0,1-.634-1.2h0l-.987-3.738c0-.008,0-.008-.006-.015a.509.509,0,0,0-.221-.331.751.751,0,0,0-.406-.1H9.875Zm6.786,5.925a.708.708,0,1,1-.708.708.708.708,0,0,1,.708-.708Zm-3.1,0a.708.708,0,1,1-.708.708.708.708,0,0,1,.708-.708ZM4.084,5.427a.527.527,0,0,1,0-1.054h8.165a.527.527,0,0,1,0,1.054ZM1.223,0H15.063a1.219,1.219,0,0,1,1.222,1.222v9.694H15.234V1.227a.171.171,0,0,0-.173-.173H1.223A.179.179,0,0,0,1.1,1.1a.168.168,0,0,0-.048.123V17.174a.179.179,0,0,0,.05.123.167.167,0,0,0,.123.05h8.9a5.837,5.837,0,0,0,.36,1.046H1.223a1.222,1.222,0,0,1-.865-.357A1.21,1.21,0,0,1,0,17.172V1.223A1.22,1.22,0,0,1,1.223,0ZM4.084,9.738a.527.527,0,0,1,0-1.054h8.165a.527.527,0,0,1,0,1.054Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.93fc4f8969b577e6b2603bad478706d2.svg";
export { ForwardRef as ReactComponent };